/* unplugin-vue-components disabled */import script from "./CustomNameCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomNameCell.vue?vue&type=script&setup=true&lang=ts"

import "./CustomNameCell.vue?vue&type=style&index=0&id=304ef0d4&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-304ef0d4"]])

export default __exports__